import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SnackbarClass, SnackbarService, SnackbarType } from '../../services/snackbar.service';

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
  private readonly snackbarService = inject(SnackbarService);
  protected readonly messages = this.snackbarService.messagesSignal;
  protected readonly SnackbarType = SnackbarType;

  protected closeSnackbar(id: string): void {
    this.snackbarService.remove(id);
  }

  protected getSnackbarClasses(type: SnackbarType): SnackbarClass {
    switch (type) {
      case SnackbarType.SUCCESS:
        return SnackbarClass.SUCCESS;
      case SnackbarType.ERROR:
        return SnackbarClass.ERROR;
      case SnackbarType.WARNING:
        return SnackbarClass.WARNING;
      case SnackbarType.INFO:
        return SnackbarClass.INFO;
    }
  }
}
